import { render, staticRenderFns } from "./StandardCardFormItems.vue?vue&type=template&id=5612d6d6&scoped=true"
import script from "./StandardCardFormItems.vue?vue&type=script&lang=js"
export * from "./StandardCardFormItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612d6d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5612d6d6')) {
      api.createRecord('5612d6d6', component.options)
    } else {
      api.reload('5612d6d6', component.options)
    }
    module.hot.accept("./StandardCardFormItems.vue?vue&type=template&id=5612d6d6&scoped=true", function () {
      api.rerender('5612d6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/standardCard-management/StandardCardFormItems.vue"
export default component.exports